module.exports = __webpack_public_path__ + "static/media/resumen.3b38cb48.svg";